import React, { FC } from 'react';
import { SC } from '../../styles/theme';
import { BRAND } from '../../constants/main';
import { HomePageOptionsStyled } from './HomePageOptionsStyled';
import { HomePageOptionsStyledAP } from './AP/HomePageOptionsStyled.AP';
import { HomePageOptionsStyledAC } from './AC/HomePageOptionsStyled.AC';
import { HomePageOptionsStyledOV } from './OV/HomePageOptionsStyled.OV';
import { HomePageOptionsStyledDS } from './DS/HomePageOptionsStyled.DS';
import { BrandTypes } from '../../types/brands';

export interface HomePageOptionsProps extends SC {
    isStockAvailable: boolean;
    isConfigurableAvailable: boolean;
}

const HomePageOptions: FC<HomePageOptionsProps> = (props): JSX.Element => {
    if (BRAND === BrandTypes.AC) return <HomePageOptionsStyledAC {...props} />;
    if (BRAND === BrandTypes.OV) return <HomePageOptionsStyledOV {...props} />;
    if (BRAND === BrandTypes.AP) return <HomePageOptionsStyledAP {...props} />;
    if (BRAND === BrandTypes.DS) return <HomePageOptionsStyledDS {...props} />;
    return <HomePageOptionsStyled {...props} />;
};

export default HomePageOptions;
